module.exports = __webpack_public_path__ + "static/media/4.1ca7d2e0.jpg";